var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"items":_vm.runnablesList,"label":"Add a runnable","prepend-icon":"loop","item-value":"name"},on:{"change":_vm.selectRunnable},scopedSlots:_vm._u([{key:"item",fn:function(ref){
var item = ref.item;
var index = ref.index;
return [_c('div',[_c('p',{staticClass:"select_name"},[_vm._v(_vm._s(item.name))]),((item.tooltip.indexOf('@warn')) > -1)?_c('p',{staticClass:"select_tooltip"},[_vm._v(_vm._s(item.tooltip.substring(0, item.tooltip.indexOf('@warn'))))]):_c('p',{staticClass:"select_tooltip"},[_vm._v(_vm._s(item.tooltip))])])]}},{key:"selection",fn:function(ref){
var item = ref.item;
var index = ref.index;
return [_vm._v(_vm._s(item.name))]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }